import MobilePageContent from 'app/pages/mobile/mobile-layout/MobilePageContent';
import { BACKGROUND_SIZES } from 'app/pages/mobile/utils/constants';
import { Box, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { useSettingsMenuActions } from 'app/pages/mobile/pages/mobile-settings/shared/hooks/useSettingsMenuActions';

const MobileReviewPage = () => {
  const { t } = useTranslation();
  const { handleSignOut } = useSettingsMenuActions();

  return (
    <MobilePageContent
      title={t('mobileReview.returnToLogin')}
      hideNavBar={true}
      transparentHeight={BACKGROUND_SIZES.TITLE}
      onBack={handleSignOut}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          textAlign: 'center',
          gap: 2,
        }}
      >
        <Typography>{t('mobileReview.accountUnderReview')}</Typography>
        <Typography variant="caption">{t('mobileReview.accountUnderReviewDescription')}</Typography>
      </Box>
    </MobilePageContent>
  );
};

export default MobileReviewPage;
